/** @param {import('./runApiCompletionStream.js').ApiCompletionCtx} ctx */
export function reportApiCompletionFailure(ctx, message) {
  const { tid, pendingId, session, setMessagesByThreadId } = ctx
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = {
      ...next[idx],
      text: `Could not get a reply.\n\n${message}`,
      createdAt: Date.now(),
    }
    return { ...inner, [tid]: next }
  })
  session.dispose()
}
